"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TableColumnDisplayType;
(function (TableColumnDisplayType) {
    TableColumnDisplayType["raw"] = "raw";
    TableColumnDisplayType["contextMenu"] = "contextMenu";
    TableColumnDisplayType["checkbox"] = "checkbox";
    TableColumnDisplayType["changeIndicator"] = "changeIndicator";
    TableColumnDisplayType["morningstarRating"] = "morningstarRating";
    TableColumnDisplayType["link"] = "link";
    TableColumnDisplayType["expander"] = "expander";
    TableColumnDisplayType["color"] = "color";
    TableColumnDisplayType["scale"] = "scale";
    TableColumnDisplayType["weightingBar"] = "weightingBar";
    TableColumnDisplayType["icon"] = "icon";
    TableColumnDisplayType["actions"] = "actions";
    TableColumnDisplayType["barScale"] = "barScale";
})(TableColumnDisplayType = exports.TableColumnDisplayType || (exports.TableColumnDisplayType = {}));
